import { IconButtonV2 } from "src/components/IconButtonV2/IconButtonV2.tsx";
import React, { useState } from "react";
import {
  autoUpdate,
  flip,
  FloatingFocusManager,
  FloatingOverlay,
  FloatingPortal,
  offset,
  useDismiss,
  useFloating,
  useInteractions,
} from "@floating-ui/react";
import * as styles from "./RefreshButton.styles.ts";
import { FLOATING_PORTAL_ROOT_ID } from "src/common/constants.ts";
import { useResourceFormApi } from "src/components/Form/hooks/useResourceFormApi.ts";

export const RefreshButton = () => {
  const formApi = useResourceFormApi();
  const [isOpen, setIsOpen] = useState(false);
  const floating = useFloating({
    open: isOpen,
    onOpenChange: setIsOpen,
    placement: "bottom-start",
    whileElementsMounted: autoUpdate,
    middleware: [offset(7), flip({ padding: 10 })],
  });

  const interactions = useInteractions([useDismiss(floating.context)]);

  const handleRefresh = () => {
    formApi.refresh?.({
      revalidateData: true,
      resetForm: true,
    });
  };
  return (
    <>
      <IconButtonV2
        skin="info"
        size="sm"
        variant="outlined"
        onContextMenu={(e) => {
          e.preventDefault();
          setIsOpen(true);
        }}
        onClick={handleRefresh}
        ref={floating.refs.setReference}
        {...interactions.getReferenceProps()}
      >
        <span className={"icon-15-update"} />
      </IconButtonV2>
      {isOpen && (
        <FloatingPortal id={FLOATING_PORTAL_ROOT_ID}>
          <FloatingFocusManager
            context={floating.context}
            modal={true}
            returnFocus={true}
          >
            <FloatingOverlay css={styles.floatingOverlay}>
              <div
                css={styles.floatingContainer}
                ref={floating.refs.setFloating}
                tabIndex={-1}
                style={{
                  ...floating.floatingStyles,
                }}
                {...interactions.getFloatingProps()}
              >
                <div css={styles.list}>
                  <div
                    css={styles.listItem()}
                    {...interactions.getItemProps({
                      onClick: () => {
                        formApi.refresh({
                          revalidateData: false,
                          resetForm: true,
                        });
                        setIsOpen(false);
                      },
                    })}
                  >
                    Reset form
                  </div>
                  <div
                    css={styles.listItem()}
                    {...interactions.getItemProps({
                      onClick: () => {
                        formApi.refresh({
                          revalidateData: true,
                          resetForm: false,
                        });
                        setIsOpen(false);
                      },
                    })}
                  >
                    Revalidate data
                  </div>
                  <div
                    css={styles.listItem()}
                    {...interactions.getItemProps({
                      onClick: () => {
                        formApi.refresh({
                          revalidateData: true,
                          resetForm: true,
                        });
                        setIsOpen(false);
                      },
                    })}
                  >
                    Reset form and revalidate data
                  </div>
                </div>
              </div>
            </FloatingOverlay>
          </FloatingFocusManager>
        </FloatingPortal>
      )}
    </>
  );
};
